import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { matchSorter } from 'match-sorter'
import { Autocomplete } from '@material-ui/lab'

const SchoolAutocomplete = ({
  options,
  label,
  handleChange,
  handleClose,
  arrayHelpers: { form, unshift },
  schools,
  optionSelected,
  setOptionSelected,
  isEditing,
  showLoading,
  hideLoading,
  error,
  helperText,
  hasSelectAll,
  disableClearable,
  disabled,
}) => {
  const [currentList, setCurrentList] = useState([])

  useEffect(() => {
    const getCurrentList = () => {
      return options
        .filter(school => !schools.find(selectedSchool => school.id === selectedSchool.id))
        .sort((a, b) => {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
    }

    const listWithOutSelected = getCurrentList()
    setCurrentList(listWithOutSelected)
  }, [options, schools, optionSelected])

  const filterOptions = (opt, { inputValue }) =>
    matchSorter(opt, inputValue, {
      keys: [
        { threshold: matchSorter.rankings.CONTAINS, key: 'name' },
        { threshold: matchSorter.rankings.CONTAINS, key: 'inep' },
      ],
    })

  const handleSchool = value => {
    if (!value && typeof handleClose === 'function') handleClose()

    setOptionSelected(value)

    if (value && value.id) {
      const selectedSchools = schools.filter(school => school.id === value.id)

      if (selectedSchools.length === 0) unshift(value)
      if (typeof handleChange === 'function') handleChange(value)
    }
  }

  const handleSchoolChange = async (event, selected) => {
    if (selected && selected.value === 'select-all') {
      showLoading()

      setTimeout(() => {
        form.setValues({
          cities: form.values.cities,
          name: form.values.name,
          number: form.values.number,
          schools: [...schools, ...currentList.filter(school => school.value !== 'select-all')],
          state: form.values.state,

          regional: form.values.regional,
          rows: form.values.rows,

          competencies: form.values.competencies,
          description: form.values.description,
          grades: form.values.grades,
          regionals: form.values.regionals,
          schoolYear: form.values.schoolYear,

          userId: form.values.userId,
          email: form.values.email,
          cpf: form.values.cpf,

          status: form.values.status,
          initialDate: form.values.initialDate,
          startDate: form.values.startDate,
          finalDate: form.values.finalDate,
          endDate: form.values.endDate,
          classrooms: [],
          unityType: form.values.unityType,
          unitType: form.values.unitType,
          enabled: form.values.enabled,
          resetPassword: form.values.resetPassword,
        })
        hideLoading()
      })
    }
    return handleSchool(selected)
  }

  return (
    <Autocomplete
      disabled={(isEditing && isEditing === true) || disabled}
      disableCloseOnSelect
      disableListWrap
      options={currentList}
      getOptionLabel={option => {
        if (option) {
          if (option.name && option.inep) return `${option.inep} - ${option.name}`
          if (option.name && !option.inep) return `${option.name}`
        }
        return null
      }}
      disableClearable={disableClearable}
      onKeyDown={() => {}}
      filterOptions={(opt, params) => {
        const filtered = filterOptions(opt, params)
        if (options.length > 0 && currentList.length > 0 && hasSelectAll) {
          return [{ name: 'SELECIONAR TODAS', value: 'select-all' }, ...filtered]
        }
        return [...filtered]
      }}
      onChange={(event, value) => handleSchoolChange(event, value)}
      noOptionsText="Nenhuma opção disponível"
      value={optionSelected}
      renderInput={params => (
        <TextField
          {...params}
          error={error}
          helperText={helperText}
          label={label}
          variant="outlined"
          fullWidth
        />
      )}
    />
  )
}

SchoolAutocomplete.propTypes = {
  arrayHelpers: PropTypes.object.isRequired,
  disableClearable: PropTypes.bool,
  error: PropTypes.bool,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  handleReset: PropTypes.func,
  hasSelectAll: PropTypes.bool,
  label: PropTypes.string.isRequired,
  options: PropTypes.array,
  schools: PropTypes.array.isRequired,
}

SchoolAutocomplete.defaultProps = {
  handleChange: () => {},
  handleClose: () => {},
  handleReset: () => {},
  options: [],
  error: false,
  hasSelectAll: true,
  disableClearable: false,
}

export default React.memo(SchoolAutocomplete)
